import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "response"];
  static values = { templates: Array };

  apply() {
    const id = this.selectTarget.value;
    const template = this.templatesValue.find((t) => t.id === id);
    if (!template || !this.hasResponseTarget) return;
    this.responseTarget.value = template.body;
    this.selectTarget.value = "";
  }
}
